export default __webpack_public_path__ + "static/media/security.d71827db.jpeg";